import { omdApi } from '../api';
import { RoleCopy } from './types';

const role = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    roleCopy: builder.mutation<void, RoleCopy>({
      query: (data) => ({
        url: `/v1/Role/${data.id}/copy`,
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const { useRoleCopyMutation } = role;
